import React, { useRef, useState } from "react"
import { useParams } from "react-router"

import Title from '@base/Title'
import Toast from '@base/Toast'

import CartoesTableView from "@pages/Escola/Cartoes/componentes/CartoesTableView"

import { ProcessoResolver } from "@helpers/ProcessoHelper"

export const ListagemCartoes = () => {
	const toastRef = useRef(null);

	const params = useParams();
	const processo = ProcessoResolver(params.processo);

	const [horaUltimoRefresh, setHoraUltimoRefresh] = useState();
  const colunas = [
    { label: 'Nome', name: 'nomeAluno', filter: 'aluno.nome', key: false },
    { label: 'Nível', name: 'nivel', key: false },
  //  { label: 'Sexo ', name: 'sexo', filter: 'aluno.sexo', key: false, func: (c) => c ? c.map(c => c.descricao).join("/") : "", },
   // { label: 'Ano Escolar', name: 'anoEscolar', filter: 'aluno.anoEscolar', key: false, func: (c) => c ? c.map(c => c.descricao).join("/") : "" },
   // { label: 'Turno', name: 'turno', filter: 'aluno.turno', key: false, func: (c) => c ? c.map(c => c.descricao).join("/") : "" },
    { label: 'Nota', name: 'nota', key: false },
    { label: 'Nota Calculada', name: 'notaCalculada', key: false },
    { label: 'Data de recebimento', name: 'dataRecebimento', key: false }]
  //  { label: 'Participa 2ª fase', name: 'seParticipaSegundaFase', key: false, func: (c) => c ? c.map(c => c.descricao).join("/") : "" }]
	return (
		<>
			<Toast ref={toastRef} />
			<Title>Cartões</Title>
			<CartoesTableView
				refresh={horaUltimoRefresh}
				processo={processo.id}
				permiteDescartarCartao={true}
				aoDescartarCartao={(cartao) => setHoraUltimoRefresh(new Date())}
				motivosDescarteDisponiveis={() => {
					return [{ value: 'DESCLASSIFICADO', label: 'Desclassificado' },
					{ value: 'DUPLICADO', label: 'Duplicado' },
					{ value: 'OUTRO', label: 'Outro' }];}
				}
				aoRestaurarCartao={(cartao) => setHoraUltimoRefresh(new Date())}
        colunasAdicionais={colunas}
      />
		</>
	);
}

export default ListagemCartoes;
